export default __webpack_public_path__ + "static/media/foreground.de2d151f.png";